import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import type { IconProp, SizeProp } from "@fortawesome/fontawesome-svg-core"
import style from "./FloatButton.module.css"
import Animate, { AnimationTypes } from "../Animate/Animate"
import { useTranslation } from "react-i18next"
import type { InteractionDescriptionProps } from "../InteractionTooltip/InteractionTooltip"

interface FloatButtonProps extends InteractionDescriptionProps {
  icon: IconProp
  onClick?: () => void
  color?: string
  gradient?: string
  iconColor?: string
  size?: number | string
  iconSize?: SizeProp
  bottom?: number | string
  right?: number | string
  left?: number | string
  animationDuration?: string
  animationTypes?: keyof typeof AnimationTypes
}

export function FloatButton({
  icon,
  onClick,
  color = "#007bff",
  gradient,
  iconColor = "#000000ff",
  size = 80,
  bottom = 20,
  right = 20,
  left,
  iconSize = "3x",
  animationDuration = "1s",
  animationTypes = AnimationTypes.fadeIn,
  descriptionKey,
}: FloatButtonProps) {
  const { t } = useTranslation("interactionDescriptions")

  return (
    <Animate type={animationTypes} duration={animationDuration}>
      <button
        data-interaction-description-key={descriptionKey}
        aria-label={descriptionKey ? t(descriptionKey) : undefined}
        className={style.floatBottom}
        onClick={onClick}
        style={{
          background: gradient ?? color,
          width: size,
          height: size,
          bottom,
          right,
          left,
        }}
      >
        <FontAwesomeIcon icon={icon} size={iconSize} color={iconColor} />
      </button>
    </Animate>
  )
}
